import {
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
  } from "../Types";
  
  const initialState = {
    loading: false,
    error: null,
    message: null,
  };
  
  const ForgotPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
      case FORGOT_PASSWORD_REQUEST:
        return { ...state, loading: true, error: null, message: null };
  
      case FORGOT_PASSWORD_SUCCESS:
        return { ...state, loading: false, message: action.payload.message, error: null };
  
      case FORGOT_PASSWORD_FAILURE:
        return { ...state, loading: false, error: action.payload, message: null };
  
      default:
        return state;
    }
  };
  
  export default ForgotPasswordReducer;
  